import { ScheduleMeetingMeetingModel } from './../models/ScheduleMeetingMeetingModel';
import { Component, OnInit, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
//model
import { MasterModel } from '../models/MasterModel';
import { CustomerModel } from './../models/CustomerModel';
//webservice
import { WebServiceMaster } from './../services/web.service-master';
import { WebServiceCustomer } from './../services/web.service-customer';
import { WebServiceServiceRoom } from './../services/web.service-service-room';
import { formatCurrency } from '@angular/common';

@Component({
  selector: 'app-modal-new-service-room-success',
  templateUrl: './modal-new-service-room-success.component.html',
  styleUrls: ['./modal-new-service-room-success.component.scss'],
})
export class ModalNewServiceRoomSuccessComponent implements OnInit {

  // Data passed in by componentProps
  @Input() title_header: string;
  @Input() id: number;
  @Input() code: string;
  @Input() room_id: number;
  @Input() room_name: string;
  @Input() time_date_string: string;
  @Input() time_id: number;
  @Input() time_name: string;
  @Input() price: number;
  @Input() credit_minute: number;
  @Input() vat_type_id: number;
  @Input() vat_type_name: string;
  @Input() vat_per: number;
  @Input() customer_name: string;
  @Input() customer_telephone: string;
  @Input() net_total: number;
  @Input() payment_total: number;
  @Input() payment_ref_no: string;
  @Input() payment_status_name: string;

  constructor(public modalCtrl: ModalController,
    private webServiceServiceRoom: WebServiceServiceRoom
  ) { }

  async close() {
    await this.modalCtrl.dismiss({ response: 1 });
  }

  dismiss() {
    this.modalCtrl.dismiss({
      'dismissed': true
    });
  }

  ngOnInit() {
  }

  saveData() {

    var model = new ScheduleMeetingMeetingModel();
    model.id = this.id;
    this.webServiceServiceRoom.SaveDataServiceRoomMeetingToSuccess(model).subscribe(result => {
      if (result == 'success') {
        this.dismiss();
      }
      else if (result == 'error') {
        alert('บันทึกข้อมูลไม่สำเร็จ!');
      }
    });
  }

}

